import { styled } from "@mui/material";
import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";

const Styled = {};

Styled.Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 48,
  padding: 32,
  borderRadius: 24,
  border: `4px solid ${ColorSAP.primary[20]}`,
  backgroundColor: ColorSAP.primary[10],
  boxSizing: "border-box",
}));

Styled.DescAndImage = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 24,
  width: "100%",
}));

Styled.ImagePlaceholder = styled("div")(() => ({
  position: "relative",
  width: "100%",
  height: 320,
  borderRadius: 24,
  overflow: "hidden"
}));

Styled.ImageBg = styled("div")(() => ({
  position: "absolute",
  top: 0,
  right: 0,
  width: "100%",
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
}));

Styled.ImageGradient = styled("div")(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: `linear-gradient(90deg, ${ColorSAP.primary[70]} 0%, ${ColorSAP.primary[60]} 35%, rgba(122, 125, 251, 0.95) 55%, rgba(255, 255, 255, 0) 100%)`,
}));

Styled.ImageTitle = styled("p")(() => ({
  position: "absolute",
  bottom: 32,
  left: 32,
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD,
  fontSize: 32,
  lineHeight: "42px",
  color: ColorSAP.neutral[0],
  margin: 0,
  maxWidth: 340,
  zIndex: 1,
}));

Styled.Description = styled("p")(() => ({
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
  fontSize: 18,
  lineHeight: "25px",
  color: ColorSAP.neutral[100],
  margin: 0,
}));

Styled.ProcessGrid = styled("div")(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 24,
  width: "100%",
}));

Styled.ProcessGridItem = styled("div")(() => ({
  width: "calc(50% - 12px)",
  minWidth: 0,
}));

Styled.ActionButton = styled("button")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 24,
  width: "100%",
  padding: "16px 24px",
  borderRadius: 100,
  border: "none",
  backgroundColor: ColorSAP.neutral[90],
  cursor: "pointer",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: ColorSAP.neutral[100],
  },
}));

Styled.ActionButtonLabel = styled("span")(() => ({
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD,
  fontSize: 18,
  lineHeight: "22px",
  color: ColorSAP.neutral[0],
  textTransform: "uppercase",
  whiteSpace: "nowrap",
}));

Styled.ActionButtonArrow = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  borderRadius: 40,
  backgroundColor: ColorSAP.neutral[70],
  flexShrink: 0,
}));

export default Styled;
